export default "__VITE_PUBLIC_ASSET__6f2f8ffb__"